/**
 * Unique keys for setting sections. Used to identify sections when filtering
 * (e.g. excluding super-admins section from Admin Settings Permissions page).
 */
export enum SettingSectionKeyEnum {
  Account = 'account',
  Customization = 'customization',
  Security = 'security',
  AiGrant = 'aiGrant',
  Members = 'members',
  Contents = 'contents',
  DataLossPrevention = 'dataLossPrevention',
  Integrations = 'integrations',
  SuperAdmins = 'superAdmins',
  Features = 'features',
}
